let CustomElementEvent = require('../models/CustomElementEvent');

const EVENT_TRACKING_ENDPOINT = '/custom-element-event-tracking';

class CustomElementEventLogger {

    constructor(client) {
        this.client = client;
    }

    log(eventData) {

        const eventUrl = window.location.href;
        const location = eventUrl.split("?")[0];

        const customElementEvent = new CustomElementEvent(eventData.type,
            eventData.customElementName,
            eventData.customElementValue,
            location, eventUrl);

        this.client.post(customElementEvent, EVENT_TRACKING_ENDPOINT);
    }
}

module.exports = CustomElementEventLogger;
